import axios from 'axios'

const emptyUser = {
  id: '',
  login: '',
  displayName: '',
  profileImageUrl: ''
}

export class UserService {
  static getCurrentUser () {
    return new Promise<TwitchUserInterface>((resolve, reject) => {
      axios.get('/api/u/current').then(response => {
        if (response.status === 200 && response.data != null) {
          resolve({
            id: response.data.id,
            login: response.data.login,
            displayName: response.data.display_name,
            profileImageUrl: response.data.profile_image_url
          })
        } else {
          resolve(emptyUser)
        }
      }).catch(reason => {
        reject(emptyUser)
      })
    })
  }
}
